import { motion } from "framer-motion";

const Projects = () => {
  const projects = [
    {
      title: "Control Chart Tool Development",
      description: "Developed a cross-platform mobile application for identifying anomalies in power consumption using process control methods. Implemented a Health Score to quantify deviations and integrated a time-series forecasting model with 93% accuracy to predict future anomalies from historical data.",
      tech: "Django, PostgreSQL, Flutter, Python"
    },
    {
      title: "Anaesthesia Risk Assessment",
      description: "Collaborated with doctors at AIIMS Delhi to build a deep learning system for predicting pre-operative anesthesia risk on a 1–3 scale. Processed 1,050+ handwritten medical records using a CNN-based pipeline to extract patient features and trained a model achieving 91.4% accuracy on real clinical data.",
      tech: "Python, AndroidStudio, TensorFlow"
    },
    {
      title: "Mayors ledger",
      description: "Led a 10-member team to build an end-to-end MVP during a 24-hour global hackathon at Deutsche Bank. Developed a city-building simulation that teaches financial fundamentals through investment, taxation, and budget allocation, while designing systems to balance economic growth with a citizen happiness index.",
      tech: "Unity, C#"
    }
  ];

  return (
    // <section id="projects" className="h-screen flex flex-col justify-center bg-gradient-to-b from-gray-100 to-gray-300 py-20">
    <section id="projects" className="md:h-screen min-h-screen flex flex-col justify-center bg-gradient-to-b from-gray-100 to-gray-300 py-20">
      <div className="container mx-auto px-8 text-center">
        
        {/* Animated Heading */}
        <motion.h2
          className="text-5xl font-extrabold text-gray-900 relative inline-block"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Projects
          <span className="absolute left-0 bottom-0 w-full h-1 bg-gradient-to-r from-blue-600 to-purple-500 rounded-lg"></span>
        </motion.h2>

        {/* Projects Grid */}
        <motion.div 
          className="mt-12 grid md:grid-cols-3 gap-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          {projects.map((project, index) => (
            <motion.div
              key={project.title}
              className="p-6 bg-white rounded-xl shadow-lg border border-gray-200 transition-transform hover:scale-105"
              whileHover={{ scale: 1.05 }}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              <h3 className="text-2xl font-semibold text-gray-900">{project.title}</h3>
              <p className="mt-3 text-gray-700">{project.description}</p>
              <p className="mt-3 text-sm text-gray-600 font-medium">Tech Stack: {project.tech}</p>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default Projects;
